/* eslint-disable @tencent/i18next/no-literal-string */
import {
    AnalyzerResultDescriptionAndToSelectModel,
    AnalyzerResultType,
    ITextParagraphBoxNode,
} from '../../slide-content-analyzer.interface';
import { ILineSpacingResult } from '@src/slide/application/service/slide-rating-and-improve/text/text-analyzer.interface';
import { BoxKind, IParagraphBox, ITextBox } from '@tencent/alloy-editor';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import { setParagraphProps } from '@src/slide/domain/ui-model/element-modeles/property/text/text-operation';
import { PERCENT_LINE_HEIGHT_SLIDE_TO_PPT_RATIO } from '@src/slide/infrastructure/module/independent/unit';
import { isStringVisible } from '../calculate/text-box-calculate';
import i18n from '@i18next/i18n';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export class LineSpacingResult implements ILineSpacingResult {
    public analyzerName: string;
    public description: string;
    public resultInfo: Array<ITextParagraphBoxNode>;
    public resultType: AnalyzerResultType;
    public lineAnalyzerLastParaBox?: IParagraphBox;
    public lastLineLength: number;
    public lastLineFont = 0; // -1表示不止一个字体
    public readonly minSize: number;
    private showResult: Array<AnalyzerResultDescriptionAndToSelectModel> = [];

    public constructor(analyzerName: string, description: string, minSize: number) {
        this.analyzerName = analyzerName;
        this.description = description;
        this.reset();
        this.minSize = minSize;
    }

    public reset() {
        this.resultType = AnalyzerResultType.SUCCESS;
        this.resultInfo = [];
        this.showResult = [];
        this.lastLineLength = 0;
        this.lineAnalyzerLastParaBox = undefined;
    }

    public getDescriptionWithSelect(): AnalyzerResultDescriptionAndToSelectModel[] | undefined {
        if (this.resultType === AnalyzerResultType.SUCCESS) return undefined;
        if (this.showResult.length > 0) return this.showResult;
        const result: Array<AnalyzerResultDescriptionAndToSelectModel> = [];
        for (let i = 0; i < this.resultInfo.length; i++) {
            const current = this.resultInfo[i];
            let preText = '';
            for (let j = 0; j < current.paraBox.children[0].children.length; j++) {
                const currentText = (current.paraBox.children[0].children[j] as ITextBox)?.text;
                if (isStringVisible(currentText)) {
                    preText += currentText;
                    if (preText.length > 2) {
                        break;
                    }
                }
            }
            const description = i18n.t(
                '第{0}页\'{1}\'开头的文字段落行间距小于1.2倍',
                { 0: current.slideNode.slideIndex + 1, 1: preText?.substring(0, 5) },
            );
            result.push({
                description,
                selectable: true,
                selectSlide: current.slideNode.slide,
                selectElement: current.element,
                handleProblem: this.handleItemClick,
            });
        }
        this.showResult = result;
        return result;
    }

    private handleItemClick = (index: number) => {
        if (this.showResult[index].selectSlide?.sdkData
            && this.showResult[index].selectElement?.sdkData) {
            const currentItem = this.resultInfo[index];
            const toUpdateParagraphList = this.prepareParagraphList(currentItem);
            const element: IShapeModel = currentItem.element as IShapeModel;
            element.updateParagraphList(toUpdateParagraphList);
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.AUTO_BEAUTIFY,
                action: TDWActionType.BEAUTIFY_LINE_SPACE,
            });
        }
        this.removeOneResult(index);
    };

    private removeOneResult(index: number) {
        this.resultInfo.splice(index, 1);
        this.showResult.splice(index, 1);
        if (this.showResult.length === 0) this.resultType = AnalyzerResultType.SUCCESS;
    }

    private prepareParagraphList(currentItem: ITextParagraphBoxNode): IParagraph[] {
        const element: IShapeModel = currentItem.element as IShapeModel;
        if (!element.paragraphList) return [];
        const paraIndex = this.getParagraphIndexFromBox(currentItem.paraBox);
        const newPara = setParagraphProps(element.paragraphList, {
            PPTLineHeight: this.minSize,
            lineHeight: this.minSize * PERCENT_LINE_HEIGHT_SLIDE_TO_PPT_RATIO,
            lineHeightIs: 'percent',
        }, [paraIndex]);
        return newPara;
    }

    private getParagraphIndexFromBox(paraBox: IParagraphBox): number {
        let currentBox: any = paraBox;
        while (currentBox.children && currentBox.children.length > 0) {
            currentBox = currentBox.lastChild;
            if (currentBox.kind === BoxKind.Text) {
                break;
            }
        }
        const documentElementPath: Array<number> | undefined = (currentBox as ITextBox)
            // @ts-ignore
            .textStyle?.getCustomizeProp?.('slatePath');
        return documentElementPath?.[0] || 0;
    }
}

